import {
  SET_ASSESSMENT_ID,
  SET_RESPONSE,
  SET_RESPONSES,
  UPDATE_MINUTES_LEFT,
  SET_STATUS,
  CLEAR_RESPONSES,
  AssessmentActionTypes,
} from '../types/assessment';

export const setAssessmentId = (id: string): AssessmentActionTypes => ({
  type: SET_ASSESSMENT_ID,
  payload: id,
});

export const setResponse = (key: string, value: any): AssessmentActionTypes => ({
  type: SET_RESPONSE,
  payload: { key, value },
});

export const setResponses = (responses: Record<string, any>): AssessmentActionTypes => ({
  type: SET_RESPONSES,
  payload: responses,
});

export const updateMinutesLeft = (minutes: number): AssessmentActionTypes => ({
  type: UPDATE_MINUTES_LEFT,
  payload: minutes,
});

export const setStatus = (status: 'started' | 'completed' | 'abandoned'): AssessmentActionTypes => ({
  type: SET_STATUS,
  payload: status,
});

export const clearResponses = (): AssessmentActionTypes => ({
  type: CLEAR_RESPONSES,
});

// Helper to get response by prefix
export const getResponseByPrefix = (responses: Record<string, any>, prefix: string): Record<string, any> => {
  return Object.keys(responses)
    .filter(key => key.startsWith(prefix))
    .reduce((acc, key) => {
      acc[key] = responses[key];
      return acc;
    }, {} as Record<string, any>);
};
